<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="requestrrd">
              <i class="fa fa-file"></i>Request RRD
            </b-dropdown-item>
            <b-dropdown-item @click="approvalConfirm" :disabled="!model.requestkey">
              <i class="fa fa-send"></i>Send Appoval Request
            </b-dropdown-item>
          </b-dropdown>
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.agreement"
                  placeholder="No Agreement"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>RRD Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
            <b-input-group-prepend> </b-input-group-prepend>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 100px">No. Kontrak</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.nomor"
              placeholder="No Kontrak"
            ></b-form-input>
            <b-form-select v-model="tblData.status_approval" :plain="true" :options="status_approval"></b-form-select>
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="refresh()"
                class="ml-3"
              >
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          @row-clicked="rowClicked"
          show-empty
        >
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(tgl_kontrak)="data">{{
            data.item.tgl_kontrak | moment("DD/MM/YYYY")
          }}</template>
          <template v-slot:cell(no_agreement)="data">
            <a :href="viewagreementcard(data.item.pinjamankey)" target="_blank" title="View Aggrement Card">{{data.item.no_agreement}}</a>
          </template>
          <template v-slot:cell(value_of_asset)="data">{{
            data.item.value_of_asset | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(plafon)="data">{{
            data.item.plafon | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(principal)="data">{{
            data.item.principal | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(installment_amount)="data">{{
            data.item.installment_amount | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(denda_tarifhri)="data">{{
            data.item.denda_tarifhri | numFormat("0,0.0000")
          }}</template>
          <template v-slot:cell(bungaod_tarifbln)="data">{{
            data.item.bungaod_tarifbln | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bunga_tarifthn)="data">{{
            data.item.bunga_tarifthn | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(tenor)="data">{{
            data.item.tenor | numFormat
          }}</template>
          <template v-slot:cell(startdate)="data">{{
            data.item.startdate | moment("DD/MM/YYYY")
          }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YYYY")
          }}</template>
          <template v-slot:cell(expired_date)="data">{{
            data.item.expired_date | moment("DD/MM/YYYY")
          }}</template>
          <template v-slot:cell(npf_stop_accrue)="data">
            <span v-if="data.item.npf_stop_accrue" class="bg-danger p-1"
              >Stop Accrued</span
            >
            <span v-else class="bg-success p-1">Accrued </span>
          </template>
          <template v-slot:cell(wo_status)="data">
            <span v-if="data.item.wo_status"
              >WO</span
            >
            <span v-else>NORMAL</span>
          </template>
           <template v-slot:cell(rrd_dt)="data">
             <span v-if="(data.item.rrd_dt||'')!=''">{{
              data.item.rrd_dt | moment("DD/MM/YYYY")
              }}</span>
          </template>
          <template v-slot:cell(requestdate)="data">
             <span v-if="(data.item.requestdate||'')!=''">{{
              data.item.requestdate | moment("DD/MM/YYYY")
              }}</span>
          </template>
          <template v-slot:cell(tiperelease)="data">
             <span v-if="data.item.tiperelease ==='self'">Diambil Sendiri oleh Debitur</span>
             <span v-if="data.item.tiperelease ==='package'">Kirim via Paket</span>
             <span v-else></span>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Request Form RRD" size="lg" :centered="true" hide-footer>

          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Aggrement</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_agreement"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Kontrak</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_kontrak"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Debitur Name</label></b-input-group-prepend>
                      <b-form-input v-model="model.CustName"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Debitur No. (CIF)</label></b-input-group-prepend>
                      <b-form-input v-model="model.CustCode"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row > 
          <hr />
          <b-row>
              <b-col md="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestdate" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">    
                  <b-input-group>
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestby" readonly></b-form-input>                                        
                  </b-input-group>
                  <b-input-group>
                      <b-input-group-prepend><label>Release to</label></b-input-group-prepend>
                      <b-form-input v-model="model.releaseto" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <span><a :href="viewrequestdetail(this.model.requestkey)" target="_blank" title="View Request RRD"><i class="fa fa-eye"></i> View Request RRD</a></span>
              </b-col>
          </b-row >
          <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Keterangan</label></b-input-group-prepend>
              <b-form-textarea
                id="textarea"
                v-model="model.uraianrequest"
                placeholder=""
                rows="3"
                max-rows="6"
                readonly
              ></b-form-textarea>
          </b-input-group>

          <div v-if="(this.model.send2wfrequest==1)">
            <label class="mt-3"><h6>Workflow process history</h6></label>
              <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="220px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="120px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p>
                  </td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="6" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="danger" class="ml-1" @click="showApprovalcancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
              <b-row class="justify-content-center mt-4" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send Approval Request</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalcancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal id="modal-prevent-closing"
      v-model="showExpiredConfirm" title="Expired Memo" :centered="true" @show="resetModal"
      @hidden="resetModal" @ok="handleExpiredOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <p class="mb-1">The selected a row of data will be expired?</p>
          <b-form-group
            label="Note"
            label-for="name-input"
            invalid-feedback="Note is required"
            :state="!$v.frmDtExpired.expired_note.$error"
          >
              <b-form-input
                id="name-input"
                v-model="frmDtExpired.expired_note"
                :state="!$v.frmDtExpired.expired_note.$error"
                required
              ></b-form-input>
            </b-form-group>
          </form>
      </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import releasedoc from "../../apis/releasedoc";
import task from "../../apis/task";
import project from "../../apis/project";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();
export default {
  components: { myNumber, Loading },
  mixins: [validationMixin],
  validations: {
    frmDtExpired:{expired_note:{required}}
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalcancelConfirm: false,
      showExpiredConfirm:false,
      model: {},
      frmDtExpired:{expired_note:""},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "requestdate",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",
        status_approval: "",
        sourceproject: this.$store.state.user.compcode || "",
        contract_status:"",
        wo_status: "",
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        { value: "LIV", text: "Live"},
        { value: "ICP", text: "Incomplete Payment"},
        { value: "RRD", text: "Ready Release Document"},
      ],
      status_approval: [
        { value: "", text: "--- ALL ---" },
        { value: "Send Approval", text: "Send Approval" },
        { value: "Approved", text: "Approved (EXP)" },
        { value: "Rejected", text: "Rejected" },
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
      wostatus: dropdown.woStatus,
    };
  },
  computed: {
    invalidFrmDtExpired() {
      this.$v.frmDtExpired.$touch();
      return this.$v.frmDtExpired.$invalid;
    },
    tblFields() {
      const fields = [
        {
           key: "requestno",
          label: "No RRD",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "min-width:200px",
          sortable: true,
        },
        {
          key: "requestdate",
          label: "Request Date",
          thStyle: "min-width:100px",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "requestby",
          label: "Request By",
          thStyle: "min-width:200px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "releaseto",
          label: "Release to",
          thStyle: "min-width:200px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "status_approval",
          label: "Status Approval",
          thStyle: "min-width:100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "contract_status",
          label: "Status Pinjaman",
          thStyle: "min-width:100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "duedate",
          label: "Maturity Date",
          thStyle: "width:190px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "rrd_dt",
          label: "RRD Date",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "expired_date",
          label: "Expired Date",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tenor",
          label: "Tenor (Bulan)",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "pjxname",
          label: "Source Project",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "created_by",
          label: "Issued By",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    const collSet = {
      tablename: "vwcollector",
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce((arr = [{ value: "", text: "--- ALL ---" }], item, index) => {
      arr.push({
        value: item.pjxkey,
        text: item.pjxname,
      });
      return arr;
    }, [{ value: "", text: "--- ALL ---" }]);

    this.tblData.pjxkey = this.tblData.pjxkey || (this.sourceproject.length>0?this.sourceproject[0].value:''); 
    if(this.$route.params&&this.$route.params.contract_status){
      this.tblData.contract_status = this.$route.params.contract_status;
      this.refresh();
    }
  },
  methods: {
    async pelunasan() {
      if (this.model.pinjamankey) {
        router.push({
          name: "loan.pelunasanfrm",
          params: { pinjamankey: this.model.pinjamankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async addpinjaman() {
      router.push({ name: "loan.pinjamankabfrm" });
    },
    async revisipinjaman(data) {
      if (data) {
        for (const key in data) {
          this.model[key] = data[key];
        }
      }
      if (this.model.pinjamankey) {
        if (this.model.model_pinjaman == "PAB") {
          router.push({
            name: "loan.pinjamanABfrm",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }

        if (this.model.model_pinjaman == "PRK") {
          router.push({
            name: "loan.pinjamanRKfrm",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    async angsuran(data) {
      if (data) {
        for (const key in data) {
          this.model[key] = data[key];
        }
      }
      if (this.model.pinjamankey) {
        if (this.model.model_pinjaman == "PAB") {
          router.push({
            name: "loan.jadwalangsuran",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }

        if (this.model.model_pinjaman == "PRK") {
          toastr.warn("Harap pilih model pinjaman PRK.");
        }
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async harianDtl() {
      if (this.model.pinjamankey) {
        if (this.model.model_pinjaman === "PAB") {
          router.push({
            name: "loan.detaildendaharian",
            params: { pinjamankey: this.model.pinjamankey },
          });
        } else {
          router.push({
            name: "loan.detailbungaharian",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    async collectionDtl() {},

    async paymentHistory() {
      if (this.model.pinjamankey) {
        router.push({
          name: "loan.paymenthistory",
          params: { pinjamankey: this.model.pinjamankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    async exportDtl() {
      if (this.model.pinjamankey) {
        try {
          await pinjaman.exportDtlxls(this.model.pinjamankey);
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to export detail");
      }
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        const list = await releasedoc.readyreleasedocument(this.tblData);
        console.log('list',list)
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.collectability = "";
      this.tblData.sourceproject = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nomor = "";
      this.tblData.agreement = "";
      this.tblData.dod1 = 0;
      this.tblData.dod2 = 0;
      this.tblData.status = "";
      this.tblData.status_approval = "";
      this.tblData.wo_status = "";
      this.tblData.pjxkey = "";
      this.refresh();
    },
    async exportxls() {
      try {
        await releasedoc.exportxlsRRD(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
  

    resetModal() {
      this.frmDtExpired.expired_note = ''
    },
    handleExpiredOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (this.invalidFrmDtExpired) {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
          return;
      }
      this.expireddata()
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    approvalConfirm: async function () {
        if (this.model.requestkey) {   
            this.model.rrd_dt = this.model.rrd_dt
                  ? moment(this.model.rrd_dt).format("DD MMM YYYY")
                  : "";
            this.model.requestdate = this.model.requestdate
                  ? moment(this.model.requestdate).format("DD MMM YYYY")
                  : "";
            this.model.alamatDebitur = `${this.model.alamatktp}, kecamatan: ${this.model.kecamatanktp}, kelurahan: ${this.model.kelurahanktp}, kota: ${this.model.kotaktp}`;
            this.model.value_of_asset = this.model.value_of_asset ? this.model.value_of_asset.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : "";
            if (this.model.send2wfrequest==1) {
              try {
                const data = await task.approvalhistory({key: this.model.requestkey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            //this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            formData.append('requestkey', this.model.requestkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await pinjaman.approvalpelepasandoc(formData);
            this.model.send2wf=1;
            toastr.success("Send Approval Request RRD successfully.");
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await pinjaman.approvalUndoRRD(this.model);
            this.model.send2wfrequest=0;
            this.showApprovalConfirm = false;
            toastr.success("Cancel Approval Request RRD successfully.");
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.pinjamankey) {
          this.isLoading=true;
          try {
              this.reportUrl= await task.approvalprint({key: this.model.pinjamankey});
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    viewagreementcard(pinjamankey){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey}}).route.path;
      return `#`+url;
    },

    requestrrd(){
      //console.log("#this.model rrd list: ", this.model);
      if (this.model.pinjamankey) {
          router.push({name:'loan.requestpelepasandokumenfrm',params:{requestkey:this.model.requestkey, pinjamankey:this.model.pinjamankey}});
      } else {
          toastr.warn('Please select a row that want to be Requested!');
      }
    },
    viewrequestdetail(){
      const url = router.resolve({name:'loan.requestrrdview',params:{requestkey:this.model.requestkey}}).route.path;
      return `#`+url;
    },
    close() {
      router.push("home");
    },
  },
};
</script>